export default __webpack_public_path__ + "static/media/frog.6c95f166.gif";